import React, { useState } from "react";
import "./SelectPlan.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsersLine } from "@fortawesome/free-solid-svg-icons";

type Plan = {
  id: string;
  name: string;
  price: number;
  description: string;
  features: string[];
  popular?: boolean;
};

const SelectPlan: React.FC = () => {
  const [plans] = useState<Plan[]>([
    {
      id: "basic",
      name: "Básico",
      price: 0,
      description:
        "Explora el aprendizaje adaptativo con Trixie de forma gratuita",
      features: [
        "Acceso a funciones básicas de comprensión y escritura",
        "Asistencia en lectura estándar",
        "Resúmenes y adaptaciones de texto limitados",
        "Corrección ortográfica básica",
        "Acceso limitado a materiales educativos adaptativos",
      ],
    },
    {
      id: "advanced",
      name: "Avanzado",
      price: 15,
      description: "Maximiza el potencial educativo con funciones avanzadas",
      features: [
        "Todo lo incluido en el plan Básico",
        "Asistencia en tiempo real para lectura y escritura",
        "Explicaciones didácticas personalizadas",
        "Traducción y adaptación de textos en varios idiomas",
        "Acceso ampliado a recursos educativos",
        "Soporte multimedia: texto, voz e imágenes",
      ],
      popular: true,
    },
    {
      id: "pro",
      name: "Profesional",
      price: 50,
      description: "Consigue el máximo nivel de personalización y asistencia",
      features: [
        "Todo lo incluido en el plan Avanzado",
        "Entrenamiento personalizado basado en el progreso del usuario",
        "Análisis avanzado de necesidades educativas",
        "Acceso ilimitado a materiales adaptativos y recursos digitales",
        "Soporte prioritario y asesoría educativa",
        "Integración completa con plataformas de aprendizaje",
      ],
    },
  ]);

  const handlePlanSelection = (planId: string) => {
    fetch("/api/select-plan", {
      method: "POST",
      body: JSON.stringify({ planId }),
      headers: { "Content-Type": "application/json" },
    }).then(() => {
      window.location.href = "/dashboard";
    });
  };

  return (
    <div className="container">
      <h2 className="title">Elige tu plan con Trixie</h2>
      <div className="plans-container">
        {plans.map((plan) => (
          <div
            key={plan.id}
            className={`plan-card ${plan.popular ? "popular" : ""}`}
          >
            <h3 className="plan-name">{plan.name}</h3>
            <p className="plan-price">${plan.price} USD/mes</p>
            <p className="plan-description">{plan.description}</p>
            <ul className="plan-features">
              {plan.features.map((feature, index) => (
                <li key={index} className="feature-item">
                  ✅ {feature}
                </li>
              ))}
            </ul>
            <button
              onClick={() => handlePlanSelection(plan.id)}
              className="select-button"
            >
              Seleccionar
            </button>
          </div>
        ))}
      </div>
      <div className="enterprise-message">
        <FontAwesomeIcon icon={faUsersLine} size="xl" />
        <p>¿Necesitas más funciones personalizadas para tu institución?</p>
        <p>
          Consulta{" "}
          <a href="https://ithreexglobal.com/" className="no-underline">
            Ithreex Global
          </a>
        </p>
      </div>
    </div>
  );
};

export default SelectPlan;
